import { useTranslation } from 'react-i18next';

import { SeasonalThemeId } from '~/config/seasonalTheme.config';

import styles from './SeasonalTheme.module.css';

/** Silhouette de chauve-souris (partagée avec l'écran « entre deux jeux » du téléphone). */
export function BatIcon({ className, style }: { className?: string; style?: React.CSSProperties }) {
    return (
        <svg className={className} style={style} viewBox="0 0 64 28" fill="currentColor" aria-hidden="true">
            <path d="M32 9c1.6-3 3.4-4 3.4-4l.6 3 2-1.4c0 2 1.4 3 1.4 3 4-4.6 13-6 24.6-1.4-6 1.4-8 5.4-8 8.4-3-2-6.6-2-8.6 1-1.6-2-4.4-2.4-6.4-.6C39 19 35 21 32 25c-3-4-7-6-9-8.4-2-1.8-4.8-1.4-6.4.6-2-3-5.6-3-8.6-1 0-3-2-7-8-8.4C11.6 3.2 20.6 4.6 24.6 9.2c0 0 1.4-1 1.4-3l2 1.4.6-3S30.4 6 32 9z" />
        </svg>
    );
}

/** Annonce de la soirée, pour l'emplacement central de la barre du haut (Navbar `center`). */
export function SeasonalPill({ id }: { id: SeasonalThemeId }) {
    const { t } = useTranslation();
    return (
        <div className={styles.pill} role="note">
            <span aria-hidden="true">🎃</span>
            <span className={styles.pillLabel}>{t(`home.seasonal.${id}.pill`)}</span>
            <span className={styles.pillHint}>· {t(`home.seasonal.${id}.pillHint`)}</span>
        </div>
    );
}

/** Lune et chauves-souris sur le menu TV (sous le contenu). */
export function SeasonalHomeDecor() {
    return (
        <div className={styles.decor} aria-hidden="true">
            <div className={styles.moon} />
            <BatIcon className={styles.bat} />
            <BatIcon className={styles.bat} />
            <BatIcon className={styles.bat} />
        </div>
    );
}
